<template>
	<div>
		<div v-if="getBeFilter().promo_code != ''" class="w-100 pt-3 border-top">
	    <div v-if="detail.is_load" class="w-100 text-center">
	      <loader />
	    </div>
	    <template v-else>
	      <div v-if="detail.error != ''" class="w-100">
	        <ErrorMessage :message="detail.error" />
	      </div>
	      <div class="py-3 px-2 mb-2 border radius-0 d-block position-relative" style="background-color: rgb(243, 255, 244); border-color: rgb(193, 254, 184) !important;">
	        <div class="row no-gutters">
	          <div @click="toggleDetail(detail.data)" class="col-2 align-self-center cursor-pointer">
	            <div class="bg-green p-2 rounded-100 d-table mx-auto" style="line-height: 0 !important">
	              <!-- <img src="../../../../assets/img/icon/correct-white.png" width="15" class="position-relative"> -->
	              <i class="simple-icon-tag text-22 text-white"></i>
	            </div>
	          </div>
	          <div @click="toggleDetail(detail.data)" class="col-10 align-self-center cursor-pointer">
	            <div class="mx-2">
	              <!-- <p class="mb-0 body-3-3-1 text-10" v-if="is_match_product">{{$t('hotel.concierge.promotion.promotion-applied')}}</p> -->
	              <p class="mb-0 body-3-3-1 text-10">{{$t('hotel.concierge.promotion.promotion-applied')}}</p>
	              <p class="mb-0 text-green body-1-4">{{detail.data.name}}</p>
	              <p class="mb-0 body-2-2">{{detail.data.description}}</p>
	            </div>
	          </div>
	        </div>
	        <img @click="removeCurrentPromoCode" src="../../../../assets/img/icon/close.png" width="12" class="position-absolute cursor-pointer" style="top:8px;right:8px;">
	      </div>
	      <p v-if="detail.error_remove != ''" class="mb-0 body-1-4 text-danger w-100 text-center">Failed to remove promo code : {{detail.error_remove}}. Please try again</p>
	    </template>
	  </div>

	  <!-- DETAIL -->
    <template v-if="popup.data != null">
      <PopUpBackground></PopUpBackground>
      <div class="position-relative" style="z-index: 1045">
        <div class="row no-gutters justify-content-center">
          <div class="fixed-bottom d-table w-100 nav-bottom" style="top:40px">
            <div class="custom-container-fluid px-0">
              <div class="row justify-content-center no-gutters">
                <div class="col-11 rounded-4 position-relative">
                  <div class="rounded-4 bg-white" style="height: 90vh;">
                    <div class="">
                      <div class="row no-gutters">
                        <div class="col-12 position-relative">
                          <div class="w-100 rounded-4" style="overflow-y: auto;height: 90vh;">
                             <img src="../../../../assets/img/icon/cancel.png" class="d-inline-block p-2 bg-back mt-3 mx-4 cursor-pointer position-absolute rounded-3" width="33" style="z-index: 1038;right: 0" @click="toggleDetail()">
                            <div class="pb-4">
                              <div class="container px-4 py-3">
                                <p class="mb-0 body-1-4 text-20">{{popup.data.name}}</p>
                                <p class="mb-3 body-3-3-1 text-orange" v-if="avlbUseLeft(popup.data.max_use,popup.data.used) < 4">{{avlbUseLeft(popup.data.max_use,popup.data.used)}} voucher left. Grab it fast!</p>
                                <div class="mb-3 w-100">
                                  <p class="mb-0 body-2 font-regular">Promo Code:</p>
                                  <p class="mb-0 body-2-2 font-bold text-14">{{popup.data.promo_code}}</p>
                                </div>
                                <div class="mb-3 w-100">
                                  <p class="mb-0 body-2 font-regular">Apply on:</p>
                                  <p class="mb-0 body-2-2 font-bold text-14">{{applyOnParser(popup.data.apply_on)}}</p>
                                </div>
                                <div class="my-3 pb-4">
                                  <p class="mb-0 body-3-3 text-16 font-bold">{{$t('general.description')}}</p>
                                  <p class="body-3-3 text-14 font-regular">{{popup.data.description}}</p>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="position-absolute w-100 mb-3" style="bottom:-16px">
                            <div class="w-100 px-0">
                              <div class="row justify-content-center no-gutters">
                                <div class="col-12 position-relative">
                                  <div class="">
                                    <div class="w-100">
                                      <div class="container px-4 pt-2 pb-3 bg-white box-shadow-footer">
                                        <p class="mb-1 body-3-3-1 text-orange" v-if="popup.error != ''">{{popup.error}}</p>
                                        <button 
                                          @click="removeCurrentPromoCode('popup')"
                                          :disabled="popup.push_load" 
                                          :class="{'button-disabled': popup.push_load}" 
                                          class="button-secondary button-sm w-100">
                                          <pulse-loader :loading="popup.push_load" color="#fff" v-if="popup.push_load"></pulse-loader>
                                          <template v-else>Cancel</template>
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
	</div>
</template>
<script>
  import {mapGetters,mapMutations} from 'vuex';
  import {get} from '@/services/index.js';
  import PopUpBackground from '@/components/hotel/be/PopUpBackgroundDesktop.vue';
  import moment from 'moment'
  export default{
  	components:{
  		PopUpBackground
  	},
    data(){
      return{
        room_list: [],
        detail:{
          data: {},
          is_load: false,
          error: '',
          error_remove: ''
        },
        popup: {
          data: null,
          push_load: false,
          error: ''
        }
      }
    },
    mounted(){
      this.firstLoadData()
    },
    methods:{
      ...mapGetters(['getMerchant','getBeFilter','getCurrentLanguage','getBeCartRoom']),
      ...mapMutations(['setBeFilter','beReplaceDataRoomRate']),
      checkIfPromoCodeIsSame(pc_1,pc_2){
        let data_1 = pc_1.toLowerCase()
        let data_2 = pc_2.toLowerCase()
        return data_1 == data_2 ? true : false
      },
      avlbUseLeft(max,used){
        return max-used
      },
      applyOnParser(data){
        if(data == 'EVERY_NIGHT'){
          return 'Every Night'
        }else if(data == 'FIRST_NIGHT'){
          return 'First Night'
        }else if(data == 'LAST_NIGHT'){
          return 'Last Night'
        }else{
          return data
        }
      },
      firstLoadData(){
        if(this.getBeFilter().promo_code != ''){
          this.getPromoCodeApplied()
        }
      },
      toggleDetail(data=null){
        if(!this.popup.push_load){
          this.popup.data = data
          this.popup.push_load = false
          this.popup.error = ''
        }
      },
      changeVuexRoomData(type='remove',promo){
        return new Promise(done=>{
          for (let i = 0 ; i < this.getBeCartRoom().length ; i++){
            let room_rate = this.getBeCartRoom()[i].room_rate
            let rt_record = this.room_list.findIndex(rt=>rt.id == room_rate.room_type.id)
            if(rt_record != -1){
              let rr_record = this.room_list[rt_record].room_rate.findIndex(rr=>rr.id == room_rate.id)
              if(rr_record != -1){
                this.beReplaceDataRoomRate(this.room_list[rt_record].room_rate[rr_record])
              }
            }
            if((i+1) == this.getBeCartRoom().length){
              let params = {
                date: {
                  check_in: this.getBeFilter().date.check_in,
                  check_out: this.getBeFilter().date.check_out,
                },
                guest: {
                  adult: this.getBeFilter().guest.adult,
                  child: this.getBeFilter().guest.child,
                  infant: this.getBeFilter().guest.infant,
                },
                promo_code: type == 'replace' ? promo.promo_code : ''
              }
              this.setBeFilter(params)
              if(type == 'remove'){
                this.detail.data = {}
              }else{
                this.detail.data = promo
              }
              done(true)
            }
          }
        })
      },
      checkPromoCode(promo_id){
        return new Promise(done=>{
          let total_promo = 0
          // looping room type
          for(let i_r = 0; i_r < this.room_list.length;i_r++){
            // looping room rate
            for(let i_rr = 0; i_rr < this.room_list[i_r].room_rate.length;i_rr++){
              let room_rate = this.room_list[i_r].room_rate[i_rr]
              // looping room rate date
              for(let i_rrd = 0; i_rrd < room_rate.dates.length;i_rrd++){
                let promo_date = room_rate.dates[i_rrd].promo_combine

                if(promo_date != null){

                  let matched_promo = promo_date.promotion_list.filter(promo=>promo.promotion_type == 'PROMO_CODE' && promo.is_apply)

                  if(matched_promo.length > 0){
                    // check data to vuex
                    let v_rr = this.getBeCartRoom().findIndex(rr=>rr.room_rate.id == room_rate.id)
                    if(v_rr != -1){
                      let v_rrd = this.getBeCartRoom()[v_rr].room_rate.dates.findIndex(rrd=>rrd.date == room_rate.dates[i_rrd].date)
                      if(v_rrd != -1){

                        let check_promo_matched = matched_promo.some(x=>x.id==promo_id)
                        if(check_promo_matched){
                          total_promo++
                        }
                      }
                    }
                  }

                }
                if(total_promo > 0 || (
                  (i_r+1) == this.room_list.length && 
                  (i_rr+1) == this.room_list[i_r].room_rate.length && 
                  (i_rrd+1) == this.room_list[i_r].room_rate[i_rr].dates.length 
                  )){
                  done(total_promo)
                }
              }
            }
          }
        })
      },
      async applyPromoCode(){
        let promotion = this.detail.data
        let room_response = await this.getRoomList(promotion.promo_code).then(response=>{return response})
        if(room_response == true){
          const total_promo = await this.checkPromoCode(promotion.id).then(res=>{
            return res
          })
          if(total_promo > 0){
            this.changeVuexRoomData('replace',promotion).then(()=>{
            })
          }else{
            this.detail.error = 'Sorry, this promo has no effect on the room you have selected'
          }
        }else{
          this.detail.error = 'Error while trying to apply promo code. Please try again'
        }
      },
      removeCurrentPromoCode(type="selected",index){
				if(type == 'selected'){
          this.detail.is_load = true
          this.detail.error_remove = ''
        }else{
          this.popup.push_load = true
          this.popup.error = ''
        }
        this.getRoomList().then(response=>{
          if(response == true){
            this.changeVuexRoomData().then(()=>{
              if(type == 'selected'){
                this.detail.is_load = false
              }else{
                this.popup.push_load = false
                this.toggleDetail()
              }
            })
          }else{
            if(type == 'selected'){
              this.detail.is_load = false
              this.detail.error_remove = response
            }else{
              this.popup.push_load = false
              this.popup.error = response
            }
          }
        })
      },
      getPromoCodeApplied(){
        this.detail = {
          data: {},
          is_load: false,
          error: '',
          error_remove: ''
        }
        this.getPromoCodeDetail(this.getBeFilter().promo_code).then(response=>{
          if(response.success){
            this.detail.data = response.data
            this.applyPromoCode()
          }else{
            this.detail.error = response.message
          }
          this.detail.is_load = false
        })
      },
      getRoomList(promo_code = ''){
        return new Promise(done=>{
          let params = { 
            merchant_id: this.getMerchant().id,
            check_in_date: moment(this.getBeFilter().date.check_in).format("YYYY-MM-DD"),
            check_out_date: moment(this.getBeFilter().date.check_out).format("YYYY-MM-DD"),
            adult: this.getBeFilter().guest.adult,
            child: this.getBeFilter().guest.child,
            infant: this.getBeFilter().guest.infant,
            sort_by: 'room_type',
            price_min: '',
            price_max: '',
            language_code: this.getCurrentLanguage(),
            device: 'DESKTOP',
            use_promotion_combine:true
          }
          if (promo_code != '') {
            params.promo_code = promo_code
          }

          get("CORE_HOTEL", "search-room",
            params
          ).then(response => {
            let res = response.data
            if (res.success) {
              this.room_list = res.data.map(x=>{
                x.room_rate = x.room_rate.map((y,y_i)=>{
                  let id_ori = y.id
                  y.id_ori = id_ori
                  y.id = `${id_ori}_${y_i}`
                  return y
                })
                return x
              })
              done(true)
            }else{
              done(res.message)
            }
          })

        })
      },
      getPromoCodeDetail(pc){
        return new Promise(done=>{
          get("CORE_HOTEL","promocode-detail",{
            merchant_id: this.getMerchant().id,
            check_in_date: moment(this.getBeFilter().date.check_in).format("YYYY-MM-DD"),
            check_out_date: moment(this.getBeFilter().date.check_out).format("YYYY-MM-DD"),
            promo_code: pc
          }).then(response=>{
            done(response.data)
          })
        })
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/hotel/be/mobile/promoCodeApplied.vue